<div class="relative w-full flex flex-col md:flex-row md:items-center gap-3 bg-blueGray-200 rounded px-2 py-2 mb-4">

    @if (!searchDisabled()) {
    <div class="flex-none">
        @if(!(showAdvancedSearch$ | async)) {
        <div class="bg-white flex flex-row flex-none rounded items-center justify-start pl-2 pr-1 w-80 max-w-full">
            <i class="fas fa-search text-primary-200"></i>
            <input type="text" autocomplete="off" placeholder="Search name" (input)="onValueChange($event)"
                [(ngModel)]="searchTerm"
                class="border-0 outline-none placeholder:text-sm placeholder:text-italic placeholder-primary-200 text-primary-600 text-sm focus:outline-0 focus:border-0 focus:ring-0 grow py-2 ease-linear transition-all duration-150" />
            @if(!(showingResults | async)) {
            <button type="button" (click)="onSearchClick()"
                class="bg-primary-500 text-white text-sm px-2 py-1 rounded border-none focus:outline-none whitespace-nowrap w-16">
                @if (isSearching | async) {
                <svg class="animate-spin h-5 w-5 text-white inline items-center" xmlns="http://www.w3.org/2000/svg"
                    fill="none" viewBox="0 0 24 24">
                    <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4">
                    </circle>
                    <path class="opacity-75" fill="currentColor"
                        d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z">
                    </path>
                </svg>
                } @else {
                Search
                }
            </button>
            } @else {
            <button type="button" (click)="onCancelClick()"
                class=" text-primary-500 text-sm py-1 px-2 rounded flex justify-end border-none focus:outline-none whitespace-nowrap w-16">
                <i class="fas fa-close"></i>
            </button>
            }
        </div>
        }
    </div>
    }
    <div class="flex flex-row flex-1 items-center justify-between w-full">
        @if (!searchDisabled() && advancedSearchEnabled()) {
        <button type="button" (click)="onAdvSrch()"
            class="text-primary-500 bg-transparent text-sm font-light underline flex border-none focus:outline-none whitespace-nowrap">Advanced
            Search
        </button>
        }
        <div class="flex flex-row items-center gap-8 ml-auto">
            <!-- <btn-text prefixIcon="fas fa-filter" label="Filter" [isDisabled]="showingResults"
                    (onClick)="onFilter.emit()"></btn-text> -->
            <btn-text prefixIcon="fas fa-refresh" label="Refresh" [isDisabled]="showingResults || showAdvancedSearch$"
                (onClick)="refresh()"></btn-text>
        </div>
    </div>

    @if((showAdvancedSearch$ | async) && advancedSearchEnabled()) {
    <div class="absolute z-20 top-0 left-0 mt-2 ml-2">

        <div
            class="transition-all duration-300 ease-in-out overflow-hidden bg-white shadow-xl border border-gray-200 relative w-fit h-fit rounded p-2">

            <div class="flex flex-row gap-8 items-center justify-between mb-4">
                <h1 class="font-semibold text-primary-400 text-md">Advanced Search</h1>
                <btn-icon icon="fas fa-close" textColor="text-primary-300" (click)="cancelAdvSrch()"
                    padding=""></btn-icon>
            </div>

            <ng-content></ng-content>

        </div>
    </div>
    }

</div>